import * as React from "react";
import { DataTable, shortHash } from "../ui";

export function Unspent({ address, unspent }) {
  if (!unspent) return <span className="dim">Loading UTXOs…</span>;
  if (unspent.length > 100) {
    return (
      <a target="_blank" rel="noreferrer" href={"/api/getaddressutxos/" + address}>
        {unspent.length.toLocaleString()} unspent
      </a>
    );
  }
  if (!unspent.length) return <span className="dim">No UTXOs</span>;
  return (
    <DataTable
      headers={["Txid", "Index", "Value"]}
      rows={unspent.map((u) => [
        <a className="mono" href={"index.html?route=TRANSACTION&id=" + u.txid}>
          {shortHash(u.txid)}
        </a>,
        u.outputIndex,
        (u.satoshis / 1e8).toLocaleString() + " TLS",
      ])}
    />
  );
}
